import { SourcePage } from 'Shared/types/SourcePage.type';
import PageUrls from 'Shared/constants/PageUrls.constants';

export function getSourcePage() {
  const pathname = window.location?.pathname;
  if (pathname === PageUrls.HOME_PAGE) return SourcePage.homePage;
  if (pathname?.includes('action_items')) return SourcePage.actionItems;
  if (pathname?.includes('meet')) return SourcePage.meetingMode;
  if (pathname?.includes('workspaces')) return SourcePage.workspace;
  if (pathname?.includes('team')) return SourcePage.teamPage;
  if (pathname?.includes('goals')) return SourcePage.goalDetailPage;
  if (pathname?.includes('reviews')) return SourcePage.reviewDetailPage;
  if (pathname?.includes('settings/user_management')) return SourcePage.settingsUserManagement;
  if (pathname?.includes('settings/integrations')) return SourcePage.integrationsPage;
  return null;
}
